import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { getPdfDesigns, deletePdfDesign } from './formHelpers/pdfDesignHelper';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { Link } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import './styles/formListScreen.scss';
import DataGridComponent from './formComponents/DataGridComponent';

const PdfDesignListScreen = () => {
  const { currentUser } = useContext(AuthContext);
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [servicioId, setServicioId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!currentUser?.email) return;
      try {
        setLoading(true);
        const serviciosRef = collection(db, 'servicios');
        const q = query(serviciosRef, where('admins', 'array-contains', currentUser.email));
        const snap = await getDocs(q);
        if (snap.empty) {
          setLoading(false);
          return;
        }
        const sid = snap.docs[0].id;
        setServicioId(sid);
        const list = await getPdfDesigns(sid);
        setDesigns(list);
      } catch (err) {
        console.error('Error cargando diseños PDF:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [currentUser]);

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este diseño de PDF?')) return;
    if (!servicioId) return;
    try {
      await deletePdfDesign(servicioId, id);
      setDesigns((prev) => prev.filter((d) => d.id !== id));
    } catch (err) {
      console.error('Error eliminando diseño:', err);
      window.alert('Error al eliminar: ' + err.message);
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 180, hide: true },
    { field: 'name', headerName: 'Nombre del diseño', width: 260 },
    {
      field: 'sectionsCount',
      headerName: 'Secciones',
      width: 100,
      valueGetter: (params) => (params.row.sections?.length ?? 0)
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <Link to={`/pdf-designs/edit/${encodeURIComponent(params.row.id)}`} style={{ textDecoration: 'none' }}>
            <div className="updateButton">Editar</div>
          </Link>
          <DeleteIcon className="deleteIcon" onClick={() => handleDelete(params.row.id)} />
        </div>
      )
    }
  ];

  const filteredDesigns = designs.filter((d) =>
    (d.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="data-grid-container">Cargando...</div>;

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h2 className="title-registro">Diseño PDF</h2>
        <div className="button-container">
          <div className="searchContainer">
            <input
              className="searchInput"
              placeholder="Buscar"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchIcon className="searchIcon" />
          </div>
          <div className="add-container">
            <Link to="/pdf-designs/new" className="link" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <AddIcon fontSize="small" />
              Crear diseño PDF
            </Link>
          </div>
        </div>
      </div>
      <div className="data-grid-container">
        <DataGridComponent rows={filteredDesigns} columns={columns} />
      </div>
    </div>
  );
};

export default PdfDesignListScreen;
